export default __webpack_public_path__ + "static/emailWebhook-05cc21274d7fb7d04c652b8c4fb6c4ac.svg";